<template>
  <div id="help">
    <div class="box">
      <div class="lv3Text t">积分使用说明</div>
      <el-table :data="table" style="width: 70%;margin:0 auto;" border>
        <el-table-column prop="name" label="来源" width="180"></el-table-column>
        <el-table-column label="积分奖励" width="180">
          <template slot-scope="scope">
            <div>+{{scope.row.number}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="info" label="详细说明"></el-table-column>
      </el-table>

      <div v-html="text" class="text"></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //
      serve: this.$store.state.serve,

      table: [],
      text: "",
      id:this.$route.query.id
    };
  },
  watch: {},
  created() {
    this.initData();
  },
  methods: {
    //
    initData() {
      var that = this;
      this.axios
        .get(this.serve + "/help/integral_use")
        .then(res => {
          this.table = res.data.data.table;
          this.text = res.data.data.results.content;
        });
    }
  }
};
</script>
<style lang="scss">
#help {
  .box {
    background-color: #fff;
    border: 1px solid #ddd;
    .t {
      margin-bottom: 40px;
      background: rgba(238, 238, 238, 1);
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      font-family: "MicrosoftYaHei";
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      padding-left: 40px;
    }
    .text {
      line-height: 2em;
      padding: 0 20px;
      margin: 40px 0;
       img{
         max-width: 900px;
      }
    }
  }
}
</style>